import React, {Component} from 'react';
import UserFilter from '../UserFilter'
import ErrorMessage from '../ErrorMessage'
import OkMessage from '../OkMessage'
import {client} from '../../Client';
import DataFilter from '../DataFilter'
import ElaboraButton from '../ElaboraButton'
import Moment from 'moment';
import PropTypes from 'prop-types';
import AttivitaUtenteDelGiorno from "../attivita/AttivitaUtenteDelGiorno";
import LocalDayWithDayOfWeek from "../LocalDayWithDayOfWeek";

class ConfigurazioneSpostaAttivita extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: undefined,
            filterInfo: {
                idUtente: undefined,
            },
            _loading: false,
            error: null,
            esito: null
        };
        this.onChangeUserFilter = this.onChangeUserFilter.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.spostaAttivita = this.spostaAttivita.bind(this)
        this.dataInputSelected = this.dataInputSelected.bind(this)
    }

    getFilterDescription() {
        let msg = '';
        msg += 'Sposta giorno dal ' + Moment(this.state.filterInfo.dataStart).format('DD/MM/YYYY') +
            ' al ' + Moment(this.state.filterInfo.dataEnd).format('DD/MM/YYYY');
        msg += ' Utente: ' + this.state.filterInfo.nomeUtente;
        return msg;
    }

    componentWillUnmount() {
    }

    componentDidMount() {
    }

    spostaAttivita() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.spostaAttivita(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        days: data.days,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null,
                        esito: 'OK'
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onChangeFilter(data) {
        let filter = this.state.filterInfo;
        filter.keyword = data.keyword;
        this.setState({filterInfo: filter, items: undefined})
    }

    onChangeUserFilter(idutente, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idUtente = idutente;
        filterInfo.nomeUtente = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, items:undefined})
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg}  onDismiss={()=>{this.setState({error:null})}}/>)
        }
        if (this.state.esito === 'OK'){
            return (<OkMessage title="Spostamento Attività" msg="Le attività sono state spostate correttamente"  onDismiss={()=>{this.setState({esito:null})}}/>);
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="clock icon"/> Sposta Attività di un Utente
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui one column stackable grid">
                <div className="row">
                    <div className="ten wide column">
                        <DataFilter
                            showOption={'specs'}
                            tipo={'p'}
                            showTipo={false}
                            dataDal={this.state.filterInfo.dataStart}
                            dataAl={this.state.filterInfo.dataEnd}
                            fireOnChangeOnStart={true}
                            onChange={this.onChangeData}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="eight wide column">
                        <UserFilter
                            idUtente={this.state.filterInfo.idUtente}
                            abilitato={client.isCurrentUserAdmin()}
                            itemTutti={false}
                            onChange={this.onChangeUserFilter}
                            //dataDal={this.state.filterInfo.dataStart}
                            //dataAl={this.state.filterInfo.dataEnd}
                        />
                    </div>
                </div>
                <div className="ui one column grid">
                </div>
                <div className="row">
                    <div className="column">
                        <ElaboraButton
                            text="Sposta"
                            enabled={this.dataInputSelected()}
                            onClick={this.spostaAttivita}
                        />
                    </div>
                </div>
            </div>
            </div>

            {this.dataInputSelected() ? (
                <div className="ui two column stackable grid">
                    <div className="eight wide column">
                        <br/>
                        <h3>Attività di <LocalDayWithDayOfWeek data={this.state.filterInfo.dataStart} /> </h3>
                        <AttivitaUtenteDelGiorno
                            giorno={this.state.filterInfo.dataStart}
                            idUtente={this.state.filterInfo.idUtente}
                        />

                    </div>
                    <div className="eight wide column">
                        <br/>
                        <h3>Attività di <LocalDayWithDayOfWeek data={this.state.filterInfo.dataEnd} /> </h3>
                        <AttivitaUtenteDelGiorno
                            giorno={this.state.filterInfo.dataEnd}
                            idUtente={this.state.filterInfo.idUtente}
                        />

                    </div>
                </div>) : null}
            {loader}
        </div>)
    }

    dataInputSelected() {
        return this.state.filterInfo.dataStart !== undefined && this.state.filterInfo.dataEnd !== undefined && this.state.filterInfo.idUtente !== undefined && this.state.filterInfo.idUtente !== 0;
    }
}

ConfigurazioneSpostaAttivita.contextTypes = {
    router: PropTypes.object
}

export default ConfigurazioneSpostaAttivita;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ConfigurazioneSpostaAttivita.js
 **/